export default "<h1>\r\n    Bienvenida Quantum\r\n</h1>\r\n";